import ApiClient from './ApiClient';

export type DropdownOption = {
  id: string;
  defaultText?: string;
  orderSeq?: string;
  translations: { [languageId: string]: string };
  properties: Record<string, string>;
  parentIds?: string[];
}

export type DropdownValue = {
  id: string;
  text: string;
  properties?: any;
}

export type Dropdown = {
  id?: string;
  name?: string;
  providerId?: string;
  editable?: boolean;
}

export default class DropdownApi {
  private apiClient;

  constructor(apiClient?: any) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getDropdowns() {
    return this.apiClient.get({ path: '/api/dropdowns' });
  }

  addDropdown(body: Dropdown) {
    return this.apiClient.post({ path: '/api/dropdowns', body });
  }

  listOptions(dropdownId: string): Promise<DropdownOption[]> {
    // verify the required parameter 'dropdownId' is set
    if (dropdownId === undefined || dropdownId === null) {
      throw new Error("Missing the required parameter 'dropdownId' when calling listOptions");
    }
    return this.apiClient.get({ path: `/api/dropdowns/${dropdownId}/options` });
  }

  addOption(dropdownId: string, body: DropdownOption): Promise<DropdownOption> {
    // verify the required parameter 'dropdownId' is set
    if (dropdownId === undefined || dropdownId === null) {
      throw new Error("Missing the required parameter 'dropdownId' when calling addOption");
    }
    return this.apiClient.post({ path: `/api/dropdowns/${dropdownId}/options`, body });
  }

  deleteOption(dropdownId: string, optionId: string) {
    // verify the required parameter 'dropdownId' is set
    if (dropdownId === undefined || dropdownId === null) {
      throw new Error("Missing the required parameter 'dropdownId' when calling deleteOption");
    }
    // verify the required parameter 'optionId' is set
    if (optionId === undefined || optionId === null) {
      throw new Error("Missing the required parameter 'optionId' when calling deleteOption");
    }
    return this.apiClient.del({ path: `/api/dropdowns/${dropdownId}/options/${optionId}` });
  }

  updateOption(dropdownId: string, optionId: string, body: DropdownOption): Promise<DropdownOption> {
    // verify the required parameter 'dropdownId' is set
    if (dropdownId === undefined || dropdownId === null) {
      throw new Error("Missing the required parameter 'dropdownId' when calling updateOption");
    }
    // verify the required parameter 'optionId' is set
    if (optionId === undefined || optionId === null) {
      throw new Error("Missing the required parameter 'optionId' when calling updateOption");
    }
    return this.apiClient.put({ path: `/api/dropdowns/${dropdownId}/options/${optionId}`, body });
  }

  getOptionValues(dropdownId: string, languageId: string, opts: any): Promise<DropdownValue[]> {
    // verify the required parameter 'dropdownId' is set
    if (dropdownId === undefined || dropdownId === null) {
      throw new Error("Missing the required parameter 'dropdownId' when calling getOptionValues");
    }
    // verify the required parameter 'languageId' is set
    if (languageId === undefined || languageId === null) {
      throw new Error("Missing the required parameter 'languageId' when calling getOptionValues");
    }
    return this.apiClient.get({ path: `/api/dropdowns/${dropdownId}/${languageId}/values`, params: (opts || {}) });
  }

  getDropdown(id: string) {
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling getDropdown");
    }
    return this.apiClient.get({ path: `/api/dropdowns/${id}` });
  }

  deleteDropdown(id: string) {
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling deleteDropdown");
    }
    return this.apiClient.del({ path: `/api/dropdowns/${id}` });
  }

  updateDropdown(id: string, body: Dropdown) {
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling updateDropdown");
    }
    return this.apiClient.put({ path: `/api/dropdowns/${id}`, body });
  }
}
